module.exports = __webpack_public_path__ + "static/img/contant_4.bd56b48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/contant_4.jpg
// module id = 1Q0V
// module chunks = 0